import React, { useState, useEffect } from 'react'
import { Table, Panel, Row, Col, Avatar, IconButton, Icon, Grid, Input, Message } from 'rsuite'
import './styles.less'
import TablePagination from 'rsuite/lib/Table/TablePagination'
import SaveButton from '../../components/buttons/saveButton/SaveButton'
import CancelButton from '../../components/buttons/cancelButton/CancelButton'
import { doneLoading, startLoading } from '../../utils/loading'
import { managementSearchProject } from '../../redux/actions/adminProjectManagemant'

export default function ManageProjectCoordinatorTable({
  schema: _schema,
  onSelect,
  expanded = true,
  isReload,
  ...props
}) {
  const { Column, HeaderCell, Cell } = Table
  const [displayLength, setDisplayLength] = useState(5)
  const [page, setPage] = useState(1)

  const [projectCode, setProjectCode] = useState()
  const [projectName, setProjectName] = useState()
  const [loading, setLoading] = useState()
  const [error, setError] = useState()

  const [schema, setSchema] = useState(_schema)
  const [isExpanded, setIsExpanded] = useState(expanded)

  const defaultPage = 1
  const defaultLengthMenu = [
    { value: 5, label: 5 },
    { value: 10, label: 10 },
    { value: 15, label: 15 },
  ]

  useEffect(() => {
    setIsExpanded(expanded)
  }, [expanded])

  useEffect(() => {
    console.log('isReload=', isReload)
    if (isReload) {
      onSearch()
    }
  }, [isReload])

  const handleChangeLength = (dataKey) => {
    // console.log('dataKey=', dataKey)
    setPage(1)
    setDisplayLength(dataKey)
    handleSearch(projectName, projectCode, 1, dataKey)
  }

  const handleChangePage = (dataKey) => {
    setPage(dataKey)
    handleSearch(projectName, projectCode, dataKey, displayLength)
  }

  const onSearch = () => {
    handleSearch(projectName, projectCode, page, displayLength)
  }

  const handleSearch = async () => {
    setLoading(true)
    startLoading()
    try {
      // const request = {
      //   projectCode: projectCode,
      //   projectName: projectName,
      // }

      const response = await managementSearchProject(
        projectName,
        projectCode,
        page,
        displayLength,
        'changeCoordinator'
      )

      setSchema(response?.searchForm || [])
    } catch (e) {
      setError('เกิดข้อผิดพลาดดึงข้อมูลไม่สำเร็จ กรุณาลองใหม่อีกครั้งหรือติดต่อผู้ดูแลระบบ')
    }
    doneLoading()
    setLoading(false)
  }

  const onClickClearValue = () => {
    setProjectCode('')
    setProjectName('')
    setError('')
  }

  return (
    <>
      {schema && (
        <Panel
          header={schema.header}
          collapsible
          defaultExpanded
          shaded
          expanded={isExpanded}
          onSelect={() => {
            setIsExpanded(!isExpanded)
          }}
        >
          <Grid fluid>
            <Row gutter={16}>
              <Col lg={8} md={8} sm={24} xs={24}>
                รหัสโครงการ
                <Input
                  style={{ width: '100%' }}
                  name={'projectCode'}
                  value={projectCode}
                  placeholder="ระบุรหัสโครงการ"
                  onChange={(value) => {
                    setProjectCode(value)
                  }}
                ></Input>
              </Col>
              <Col lg={16} md={16} sm={24} xs={24}>
                ชื่อโครงการ
                <Input
                  style={{ width: '100%' }}
                  value={projectName}
                  placeholder="ระบุชื่อโครงการ"
                  onChange={(value) => {
                    setProjectName(value)
                  }}
                ></Input>
              </Col>
            </Row>
            <Row style={{ marginBottom: 10, marginTop: 10 }}>
              {error && (
                <Col xs={24} sm={24} md={24} lg={24}>
                  <Message showIcon type="error" description={error} style={{ marginBottom: 10 }} />
                </Col>
              )}

              <Col xs={24} sm={24} md={6} lg={4}>
                <SaveButton icon="search" block onClick={onSearch}>
                  {`ค้นหา`}
                </SaveButton>
              </Col>
              <Col xs={24} sm={24} md={6} lg={4}>
                <CancelButton block onClick={onClickClearValue}>
                  {'ล้างข้อมูล'}
                </CancelButton>
              </Col>
            </Row>
          </Grid>

          <Table
            wordWrap
            bordered
            // cellBordered
            height={400}
            loading={loading}
            // headerHeight={headerHeightSize || 40}
            data={schema.values}
            style={{ marginTop: 10 }}
          >
            <Column width={70} align="center" fixed>
              <HeaderCell>ลำดับ</HeaderCell>
              <Cell>
                {(_, index) => {
                  return <>{index + 1}</>
                }}
              </Cell>
            </Column>

            <Column width={160} fixed>
              <HeaderCell>รหัสโครงการ</HeaderCell>
              <Cell dataKey="projectCode" />
            </Column>

            <Column width={230} fixed flexGrow={1}>
              <HeaderCell>ชื่อโครงการ</HeaderCell>
              <Cell dataKey="projectName" />
            </Column>

            <Column width={230} fixed>
              <HeaderCell>ผู้ประสานงาน</HeaderCell>
              <Cell dataKey="coordinatorName" />
            </Column>

            <Column width={120} fixed>
              <HeaderCell></HeaderCell>
              <Cell align={'center'}>
                {(rowData) => {
                  return (
                    <IconButton
                      appearance="ghost"
                      icon={<Icon appearance="ghost" icon="edit" className="bt-gost-icon-radius" />}
                      onClick={() => {
                        onSelect(rowData)
                      }}
                    >
                      เลือก
                    </IconButton>
                  )
                }}
              </Cell>
            </Column>
          </Table>

          <TablePagination
            lengthMenu={defaultLengthMenu}
            activePage={page || defaultPage}
            renderLengthMenu={(lengthMenu) => {
              return (
                <>
                  {lengthMenu}
                  {`รายการ/หน้า`}
                </>
              )
            }}
            renderTotal={(total) => {
              return <>{` ทั้งหมด ${total} รายการ`}</>
            }}
            displayLength={displayLength || 5}
            total={schema.totalSize}
            onChangePage={handleChangePage}
            onChangeLength={handleChangeLength}
          />
        </Panel>
      )}
    </>
  )
}
